import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
export const Image = styled.div`
  background-image: ${({ bgImage }) => (bgImage ? `url(${bgImage})` : "")};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: ${({ size }) => (size ? size : "")};
  height: ${({ size }) => (size ? size : "")};
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : "")};
  ${media.lessThan(breakpoints.mobile)`
        width: ${({ smallSize }) => (smallSize ? smallSize : "")};
	height: ${({ smallSize }) => (smallSize ? smallSize : "")};
        
	`}
`;
